<template>
  <div class="container" @click="$emit('click', item)">
    <div class="icon" />
    <div class="content">
      <div class="ssid">{{ item.ssid }}</div>
      <!-- <div v-if="disabled" class="disabledTip">不可认领</div> -->
    </div>
  </div>
</template>

<script>
export default {
  props: {
    ssid: String,
    item: {
      type: Object,
      default: {},
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.container {
  display: flex;
  align-items: center;
  padding: 12px 16px 12px 0;
  margin-left: 16px;
  border-bottom: 1px solid #f2f2f2;
  background: white;
}

.icon {
  width: 26px;
  height: 26px;
  margin-right: 20px;
  background: url('../../../../assets/wifi.png') center / contain no-repeat;
}

.content {
  flex: auto;
  display: flex;
  justify-content: space-between;
}

.ssid {
  color: #666;
  font-size: 16px;
}

.disabled-tip {
  color: #999;
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// index.vue?07cae7f0